import * as React from 'react';

declare global {
  interface Window {
    gapi: any; // tslint:disable-line
  }
}

interface LoginProps {
  onLoggedIn?: () => void;
}

export class LoginView extends React.Component<LoginProps, {}> {
  render() {
    return (
      <div className="main-content">
        <div className="center">
          <h1>
            Log into <strong>Pool Party</strong>
          </h1>
        </div>
        <div className="center">
          <div className="g-signin2" id="g-signin2" />
        </div>
      </div>
    );
  }

  componentDidMount() {
    const options = {
      scope: 'email profile',
      onsuccess: () => {
        if (this.props.onLoggedIn) {
          this.props.onLoggedIn();
        }
      },
    };
    window.gapi.signin2.render('g-signin2', options);
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginView.tsx